import React, { useCallback, useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import { GenericIntegrationTicketSystemListingProps } from "../genericIntegrationTicketConstants";

function ZendeskIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = columns.filter((col: any) => {
      // Zendesk does not have projectKey field
      return col.dataIndex !== "projectKey";
    });
    return updatedColumns;
  }, []);

  const extraColumns = useMemo(
    () => [
      {
        title: "Organisation",
        dataIndex: "organisationName",
        render: CellRenderers.VALUE_OR_NA,
        width: 130,
      },
      {
        title: "Form",
        dataIndex: "formName",
        render: CellRenderers.VALUE_OR_NA,
        width: 130,
      },
    ],
    [],
  );
  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        extraColumns={extraColumns}
        {...props}
      />
    </div>
  );
}

export default ZendeskIntegrationListing;
